<template>
  <div>
    <div class="row f-row">
      <div class="col col-1 docs-titles"></div>
      <div class="col col-11 docs-titles">
        User stories
      </div>
    </div>
    <div class="row f-row justify-content-center">
      <div class="col col-10 text-center">
        <DataTable
          :filters.sync="filters"
          :rowHover="true"
          :scrollable="true"
          :scrollHeight="screenHeight + 'px'"
          :selection.sync="selectedDataVar"
          :value="dataVar"
          :virtual="true"
          ref="dt"
          class="p-datatable-sm editable-cells-table"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          filterDisplay="menu"
          responsiveLayout="scroll"
          stickyHeader="true"
        >
          <template
            #header
            style="background: var(--lightbackground3)!important;"
          >
            <div
              class="flex justify-content-between align-items-center"
              style="background: var(--lightbackground3)!important;"
            >
              <span class="p-input-icon-left">
                <i class="pi pi-search" style="font-size: 0.75rem!important;" />
                <InputText
                  style="font-size: 0.75rem!important;"
                  v-model="filters['global'].value"
                  placeholder="Keyword Search"
                />
              </span>
            </div>
          </template>
          <template #empty>
            No data found.
          </template>
          <template #loading>
            Loading data. Please wait.
          </template>

          <Column
            header="Title"
            sortable
            filterField="title"
            sortField="title"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '14rem' }"
            :styles="{ 'max-width': column1Width + 'px' }"
          >
            <template #body="{data}">
              <span
                style="white-space: pre-wrap; word-break: break-all;
                vertical-align: middle!important;"
                >{{ data.title }}</span
              >
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Title Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="titleDDown"
                placeholder="Select Title"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            field="text"
            header="Explanation"
            sortable
            :styles="{ 'max-width': column2Width + 'px' }"
          >
            <template #body="{data}">
              <span
                style="white-space: pre-wrap; word-break: break-all;
                vertical-align: middle!important;"
                >{{ data.text }}</span
              >
            </template>
            <template #filter="{filterModel}">
              <InputText
                type="text"
                v-model="filterModel.value"
                class="p-column-filter"
                placeholder="Search by code"
              />
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </div>
</template>

<script>
import { FilterMatchMode, FilterOperator } from "primevue/api/";
import { getUserStories } from "@/_core/data/Documentation";
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import InputText from "primevue/inputtext";
import MultiSelect from "primevue/multiselect";

export default {
  name: "UserStories",
  components: {
    Column,
    DataTable,
    InputText,
    MultiSelect
  },
  props: {
    processData: { required: true }
  },
  data() {
    return {
      filters: {
        title: { value: null, matchMode: FilterMatchMode.IN },
        text: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
        },
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
      },
      dataVar: [],
      screenHeight: 400,
      rowHeight: 100,
      column1Width: 100,
      column2Width: 400,
      selectedDataVar: []
    };
  },
  created() {
    this.dataVar = getUserStories();
  },
  mounted() {
    this.screenHeight =
      document.getElementById("whole-page-div").clientHeight - 130;
    this.rowHeight = (this.screenHeight - 250) / 3;
    this.column1Width =
      0.25 * document.getElementById("whole-page-div").clientWidth;
    this.column2Width =
      0.75 * document.getElementById("whole-page-div").clientWidth;
  },
  computed: {
    titleDDown() {
      return this.dataVar
        .map(d => d.title)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter(d => d != null && d !== "");
    }
  }
};
</script>

<style scoped>
.p-datatable .p-datatable-tbody > tr > td {
  height: 10px !important;
}
</style>
